import React, { Component } from "react";
import { getResultSpotName } from "../../util/GetResultSpotName";
import { languages } from "../../constants/languages";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import SubmitResultDialog from "../../components/results/SubmitResultDialog";
import { isNormalInteger } from "../../util/IsNormalInteger";
import { getGameResults } from "../../util/GetGameResults";
import SubmitResultFullscreen from "../../components/results/SubmitResultFullscreen";
import Icon from "@mdi/react";
import { mdiWhistle } from "@mdi/js";
import { compareHistoryItems } from "../../util/compareHistoryItems";
import { moveTeamToPouleSpot } from "../../util/MoveTeamToPouleSpot";
import { hasSetScores } from "../../util/hasSetScores";
import {
  findTeamInPouleSpot,
  getBracketPouleKeyName,
  getBracketWinnerAndLoser,
} from "../../util/getBracketMatchOutcome";

const hasInvalidSetDrawForSetsType0 = (sets, scoring) => {
  if ((scoring.useSets || "0") !== "1") return false;
  if ((scoring.setsType || 0) !== 0) return false;
  const setKeys = Object.keys(sets || {});
  for (let i = 0; i < setKeys.length; i++) {
    const set = sets[setKeys[i]] || {};
    if (hasSetScores(set.score1, set.score2) && set.score1 === set.score2) {
      return true;
    }
  }
  return false;
};

class MatchContainer extends Component {
  state = {
    team1: "",
    team1Id: "",
    team2: "",
    team2Id: "",
    team1Loaded: false,
    team2Loaded: false,
    open: false,
    score1: null,
    score2: null,
    penalties1: null,
    penalties2: null,
    winner: null,
    extra1: {},
    extra2: {},
    sets: {},
    playerGoals: [],
    playerPoints: {},
    isMobile: false,
  };

  componentDidMount = () => {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
  };

  resize() {
    this.setState({ isMobile: window.innerWidth <= 600 });
  }

  handlePlayerPresentCheck = (e, player, matchId) => {
    e.preventDefault();

    let matches = player.matches || [];
    if (matches.indexOf(matchId) === -1) {
      matches.push(matchId);
    } else {
      matches.splice(matches.indexOf(matchId), 1);
    }

    const db = window.firebase.firestore();

    const playersRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("players");
    playersRef.doc(player.id).update({
      matches: matches,
    });
  };

  handleGoalChange = (e) => {
    let currentGoals = this.state.playerGoals;
    if (e.target.name === "new") {
      currentGoals.push(e.target.value);
    } else {
      let index = Number(e.target.name);
      if (index > -1) {
        if (e.target.value === "") {
          currentGoals.splice(index, 1);
        } else {
          currentGoals[index] = e.target.value;
        }
      }
    }
    this.setState({ playerGoals: currentGoals });
  };

  submitNewGoal = (e, id) => {
    e.preventDefault();
    let currentGoals = this.props.match.goals || [];
    currentGoals.push(id);
    const db = window.firebase.firestore();

    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");
    matchesRef.doc(this.props.match.id).update({
      goals: currentGoals,
    });
  };

  deleteGoal = (e, index) => {
    e.preventDefault();
    let currentGoals = (this.props.match.goals || []).reverse();
    currentGoals.splice(index, 1);
    const db = window.firebase.firestore();

    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");
    matchesRef.doc(this.props.match.id).update({
      goals: currentGoals.reverse(),
    });
  };

  handlePlayerPointsChange = (e, key) => {
    let currentPlayerPoints = this.state.playerPoints[key] || [];
    if (e.target.name === "new") {
      currentPlayerPoints.push(e.target.value);
    } else {
      let index = Number(e.target.name);
      if (index > -1) {
        if (e.target.value === "") {
          currentPlayerPoints.splice(index, 1);
        } else {
          currentPlayerPoints[index] = e.target.value;
        }
      }
    }
    let allPlayerPoints = this.state.playerPoints;
    allPlayerPoints[key] = currentPlayerPoints;
    this.setState({ playerPoints: allPlayerPoints });
  };

  submitPlayerStats = () => {
    const db = window.firebase.firestore();

    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");
    matchesRef.doc(this.props.match.id).update({
      goals: this.state.playerGoals,
      playerPoints: this.state.playerPoints,
    });
  };

  clearPlayerStats = () => {
    const db = window.firebase.firestore();

    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");
    matchesRef.doc(this.props.match.id).update({
      goals: [],
      playerPoints: {},
    });
  };

  handleExtraChange = (e, teamNum) => {
    let toUpdate = this.state.extra1;
    if (teamNum === 2) {
      toUpdate = this.state.extra2;
    }
    let result = e.target.value;

    if (result === "") {
      result = null;
    }
    if (result || result === null) {
      toUpdate[e.target.name] = result;
    }
    if (teamNum === 1) {
      this.setState({ extra1: toUpdate });
    } else {
      this.setState({ extra2: toUpdate });
    }
  };

  getScoring = () => {
    let poule = this.props.poulesByKey[this.props.match.poule] || {};
    let scoreType =
      poule.scoreType ||
      (poule.bracket
        ? (this.props.bracketsByKey[poule.bracket] || {})["scoreType"]
        : false) ||
      ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
        poule.division
      ] || {})[poule.fase] ||
      "default";
    return scoreType === "default"
      ? this.props.tournament
      : (this.props.tournament.scoringTypes || {})[scoreType] ||
          this.props.tournament;
  };

  // Returns true when the marked-winner checkbox is (or would be) meaningful
  // for the given inputs, i.e. this match / aggregate is a draw that requires
  // a manual tiebreaker. Mirrors the `showCheckboxes` logic in render() so the
  // three call sites (submit, handleSetsChange, handleScoreChange) stay in
  // sync with what the UI shows.
  isMarkedWinnerMeaningful = (nextSets, nextScore1, nextScore2) => {
    const match = this.props.match || {};
    const scoring = this.getScoring();
    const useSets = (scoring.useSets || "0") === "1";
    const pouleMatches = (this.props.matches || []).filter(
      (m) => m.poule === match.poule
    );
    const otherMatch =
      pouleMatches.length === 2
        ? pouleMatches.filter((m) => m.id !== match.id)[0]
        : null;

    if (useSets) {
      if (hasInvalidSetDrawForSetsType0(nextSets, scoring)) return false;
      const gameResults = getGameResults(scoring, nextSets || {});
      if (!gameResults.finished) return false;
      if (otherMatch) {
        if (
          hasInvalidSetDrawForSetsType0(otherMatch.sets || {}, scoring)
        ) {
          return false;
        }
        const otherGameResults = getGameResults(
          scoring,
          otherMatch.sets || {}
        );
        if (!otherGameResults.finished) return false;
        const otherR1 =
          otherMatch.team1 === match.team1
            ? otherGameResults.result1
            : otherGameResults.result2;
        const otherR2 =
          otherMatch.team2 === match.team2
            ? otherGameResults.result2
            : otherGameResults.result1;
        return (
          gameResults.result1 + otherR1 === gameResults.result2 + otherR2
        );
      }
      return gameResults.result1 === gameResults.result2;
    }

    if (
      nextScore1 === "" ||
      nextScore1 === null ||
      nextScore2 === "" ||
      nextScore2 === null
    ) {
      return false;
    }
    if (otherMatch) {
      if (otherMatch.score1 === null || otherMatch.score2 === null) {
        return false;
      }
      const total1 =
        Number(nextScore1) +
        Number(
          otherMatch.team1 === match.team1
            ? otherMatch.score1
            : otherMatch.score2
        );
      const total2 =
        Number(nextScore2) +
        Number(
          otherMatch.team2 === match.team2
            ? otherMatch.score2
            : otherMatch.score1
        );
      return total1 === total2;
    }
    return Number(nextScore1) === Number(nextScore2);
  };

  handleSetsChange = (e, setNum) => {
    let sets = { ...this.state.sets };
    if (sets[setNum] === undefined) {
      sets[setNum] = {};
    } else {
      sets[setNum] = { ...sets[setNum] };
    }
    let result = e.target.value;

    if (result === "") {
      result = null;
    }
    if (isNormalInteger(result) || result === null) {
      sets[setNum][e.target.name] = result;
    }

    const keepWinner = this.isMarkedWinnerMeaningful(
      sets,
      this.state.score1,
      this.state.score2
    );

    this.setState({
      sets,
      winner: keepWinner ? this.state.winner : null,
    });
  };

  // handleChange = (e) => {
  //   let toUpdate = {};
  //   let result = e.target.value;
  //   if (result === "") {
  //     result = null;
  //   }
  //   toUpdate[e.target.name] = result;
  //   this.setState(toUpdate);
  // };

  handleScoreChange = (e) => {
    let toUpdate = {};
    let result = e.target.value;
    if (result === "") {
      result = null;
    }
    toUpdate[e.target.name] = result;
    let opponentScore =
      e.target.name === "score1" ? this.state.score2 : this.state.score1;
    if (result === null || opponentScore === null || result !== opponentScore) {
      toUpdate["penalties1"] = null;
      toUpdate["penalties2"] = null;
    }
    // Only clear the marked winner if the state (including two-legged
    // aggregate) no longer represents a draw that needs a tiebreaker.
    const nextScore1 = e.target.name === "score1" ? result : this.state.score1;
    const nextScore2 = e.target.name === "score2" ? result : this.state.score2;
    if (
      !this.isMarkedWinnerMeaningful(this.state.sets, nextScore1, nextScore2)
    ) {
      toUpdate["winner"] = null;
    }
    this.setState(toUpdate);
  };

  handlePenaltiesChange = (e) => {
    let toUpdate = {};
    let result = e.target.value;
    if (result === "") {
      result = null;
    }
    toUpdate[e.target.name] = result;
    let opponentScore =
      e.target.name === "penalties1"
        ? this.state.penalties2
        : this.state.penalties1;
    if (opponentScore !== null && result !== null) {
      if (Number(opponentScore) > Number(result)) {
        toUpdate["winner"] =
          e.target.name === "penalties1"
            ? this.props.match.team2.toString()
            : this.props.match.team1.toString();
      } else if (Number(opponentScore) < Number(result)) {
        toUpdate["winner"] =
          e.target.name === "penalties1"
            ? this.props.match.team1.toString()
            : this.props.match.team2.toString();
      } else {
        toUpdate["winner"] = null;
      }
    } else {
      toUpdate["winner"] = null;
    }
    this.setState(toUpdate);
  };

  handleCheck = (event) => {
    const checked = event.target.checked;
    if (checked) {
      this.setState({ winner: event.target.name });
    } else {
      this.setState({ winner: null });
    }
  };

  handleSubmit = (e, clear = false, s1 = null, s2 = null) => {
    e.preventDefault();
    // select day to prevent going to next day automatically
    if (!this.props.manualDaySelected) {
      this.props.selectDay(this.props.selectedDay);
    }

    let poule = this.props.poulesByKey[this.props.match.poule] || {};
    let scoreType =
      poule.scoreType ||
      (poule.bracket
        ? (this.props.bracketsByKey[poule.bracket] || {})["scoreType"]
        : false) ||
      ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
        poule.division
      ] || {})[poule.fase] ||
      "default";
    let scoring =
      scoreType === "default"
        ? this.props.tournament
        : (this.props.tournament.scoringTypes || {})[scoreType] ||
          this.props.tournament;

    const useSets = (scoring.useSets || "0") === "1";

    let gameResults = getGameResults(scoring, this.state.sets);
    let setResults = "";
    Object.keys(gameResults.sets).forEach((key, i) => {
      let set = gameResults.sets[key];
      if (set.score1 !== null && set.score2 !== null) {
        setResults += set.score1 + " - " + set.score2 + ", ";
      }
    });

    if (setResults.length > 0) {
      setResults = setResults.slice(0, setResults.length - 2);
    }

    let score1 = this.state.score1;
    let score2 = this.state.score2;
    if (s1 !== null && s2 !== null) {
      score1 = s1;
      score2 = s2;
    }
    const winnerMeaningful =
      clear === false &&
      this.isMarkedWinnerMeaningful(this.state.sets, score1, score2);
    const winnerToSave =
      winnerMeaningful &&
       this.state.winner !== null &&
       this.state.winner !== undefined &&
       this.state.winner !== "" &&
       !Number.isNaN(Number(this.state.winner))
        ? Number(this.state.winner)
        : null;

    const db = window.firebase.firestore();
    let batch = db.batch();
    const matchesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("matches");

    // const teamsRef = db
    //   .collection("tournaments")
    //   .doc(this.props.tournament[".key"])
    //   .collection("teams");

    const resultNotificationsRef = db.collection("resultNotificationRequests");
    let asAdmin = false;

    let submitHistory = this.props.match.history || {};
    let markConflict = false;
    let lastId = "";
    Object.keys(this.props.match.history || {})
      .sort((a, b) => a - b)
      .forEach((h) => {
        let historyItem = this.props.match.history[h];
        if (
          historyItem.as === "team" &&
          historyItem.asId &&
          lastId !== historyItem.asId
        ) {
          if (lastId !== "") {
            markConflict = true;
          }
          lastId = historyItem.asId;
          asAdmin = true;
        }
        if (historyItem.as === "admin" && markConflict) {
          markConflict = false;
        }
      });

    let newHistoryKey = Object.keys(submitHistory).length;
    if (
      Number(score1) !== this.props.match.score1 ||
      Number(score2) !== this.props.match.score2 ||
      markConflict ||
      clear
    ) {
      submitHistory[newHistoryKey] = {
        score1: score1 !== null && clear === false ? Number(score1) : null,
        score2: score2 !== null && clear === false ? Number(score2) : null,
        penalties1:
          this.state.penalties1 !== null && clear === false
            ? Number(this.state.penalties1)
            : null,
        penalties2:
          this.state.penalties2 !== null && clear === false
            ? Number(this.state.penalties2)
            : null,
        winner: winnerToSave,
        extra1: clear ? {} : this.state.extra1,
        extra2: clear ? {} : this.state.extra2,
        sets: clear ? {} : this.state.sets,
        as: "admin",
        uid: this.props.user.uid || "",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      };

      if (
        this.props.tournament.ia &&
        !clear &&
        ((score1 !== null && score2 !== null) ||
          (setResults.length > 0 && gameResults.finished))
      ) {
        let resultString = useSets
          ? (scoring.setsType || 0) === 0
            ? gameResults.result1 + " - " + gameResults.result2
            : setResults
          : score1 +
            " - " +
            score2 +
            (this.state.penalties1 !== null && this.state.penalties2 !== null
              ? " (" +
                this.state.penalties1.toString() +
                " - " +
                this.state.penalties2.toString() +
                ")"
              : "");
        batch.set(resultNotificationsRef.doc(), {
          tournamentId: this.props.tournament[".key"],
          sent: false,
          matchId: this.props.match.id,
          as: asAdmin ? "admin" : null,
          resultString: resultString,
        });
      }
    }

    batch.update(matchesRef.doc(this.props.match.id), {
      history: submitHistory,
      score1: score1 !== null && clear === false ? Number(score1) : null,
      score2: score2 !== null && clear === false ? Number(score2) : null,
      penalties1:
        this.state.penalties1 !== null && clear === false
          ? Number(this.state.penalties1)
          : null,
      penalties2:
        this.state.penalties2 !== null && clear === false
          ? Number(this.state.penalties2)
          : null,
      winner: winnerToSave,
      extra1: clear ? {} : this.state.extra1,
      extra2: clear ? {} : this.state.extra2,
      sets: clear ? {} : this.state.sets,
    });

    if (clear) {
      this.setState({
        score1: null,
        score2: null,
        penalties1: null,
        penalties2: null,
        winner: null,
        extra1: {},
        extra2: {},
        sets: {},
        playerGoals: [],
        playerPoints: {},
      });
      this.clearPlayerStats();
    }

    if (poule.bracket) {
      let bracket = this.props.bracketsByKey[poule.bracket] || {};
      let fromPouleKeyName =
        poule.bracketRound === bracket.size && !bracket.subBracketTo
          ? poule.fase
          : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
      let resultSpotWinner = this.props.resultSpotsAll.find(
        (rs) =>
          rs.fromPoule === this.props.match.poule &&
          rs.rank === 0 &&
          rs.belongsToBracket === poule.bracket
      );
      let resultSpotLoser = this.props.resultSpotsAll.find(
        (rs) =>
          rs.fromPoule === this.props.match.poule &&
          rs.rank === 1 &&
          rs.belongsToBracket === poule.bracket
      );
      const winnerDestPoule =
        resultSpotWinner && resultSpotWinner["poule" + poule.fase];
      const winnerDestNum =
        resultSpotWinner && resultSpotWinner["numInPoule" + poule.fase];
      const loserDestPoule =
        resultSpotLoser && resultSpotLoser["poule" + poule.fase];
      const loserDestNum =
        resultSpotLoser && resultSpotLoser["numInPoule" + poule.fase];
      const vacatedSpot = { empty: true };
      const matchHasResult =
        !clear &&
        (useSets
          ? gameResults.finished
          : score1 !== null && score2 !== null);

      const occupantInSpot = (destPouleId, destNum) => {
        const destPoule = this.props.poulesByKey[destPouleId];
        const destKey = getBracketPouleKeyName(
          destPoule,
          this.props.bracketsByKey,
          poule.fase
        );
        return findTeamInPouleSpot(
          this.props.teams,
          destPouleId,
          destNum,
          destKey
        );
      };

      const winnerOccupant =
        winnerDestPoule != null &&
        occupantInSpot(winnerDestPoule, winnerDestNum);
      const loserOccupant =
        loserDestPoule != null && occupantInSpot(loserDestPoule, loserDestNum);

      // Only touch downstream spots when we're either explicitly clearing or
      // about to place a new result. A no-op submit (empty scores, clear=false)
      // must leave the bracket alone -- matching the pre-refactor behaviour.
      const shouldMutateBracket = clear || matchHasResult;

      // Vacate next-round spots before placing, including when clearing.
      if (shouldMutateBracket && winnerOccupant) {
        batch = moveTeamToPouleSpot(
          batch,
          null,
          winnerDestPoule,
          winnerDestNum,
          null,
          null,
          false,
          this.props.tournament,
          this.props.poulesByKey,
          this.props.bracketsByKey,
          this.props.resultSpotsAll,
          this.props.teams,
          poule.fase
        );
      }
      if (shouldMutateBracket && loserOccupant) {
        batch = moveTeamToPouleSpot(
          batch,
          null,
          loserDestPoule,
          loserDestNum,
          null,
          null,
          false,
          this.props.tournament,
          this.props.poulesByKey,
          this.props.bracketsByKey,
          this.props.resultSpotsAll,
          this.props.teams,
          poule.fase
        );
      }

      if (matchHasResult) {
        let pouleMatches = this.props.matches.filter(
          (match) => match.poule === this.props.match.poule
        );
        let otherMatch = pouleMatches.filter(
          (match) => match.id !== this.props.match.id
        )[0];
        const { winner, loser } = getBracketWinnerAndLoser({
          team1: this.props.match.team1,
          team2: this.props.match.team2,
          useSets,
          gameResults,
          score1,
          score2,
          markedWinner: this.state.winner,
          otherMatch,
          scoring,
        });

        if (winner !== null && loser !== null) {
          let teamWinner = findTeamInPouleSpot(
            this.props.teams,
            this.props.match.poule,
            winner,
            fromPouleKeyName
          );
          let teamLoser = findTeamInPouleSpot(
            this.props.teams,
            this.props.match.poule,
            loser,
            fromPouleKeyName
          );
          if (teamWinner && winnerDestPoule != null) {
            batch = moveTeamToPouleSpot(
              batch,
              teamWinner.id,
              winnerDestPoule,
              winnerDestNum,
              winnerOccupant ? vacatedSpot : null,
              null,
              false,
              this.props.tournament,
              this.props.poulesByKey,
              this.props.bracketsByKey,
              this.props.resultSpotsAll,
              this.props.teams,
              poule.fase
            );
          }
          if (teamLoser && loserDestPoule != null) {
            batch = moveTeamToPouleSpot(
              batch,
              teamLoser.id,
              loserDestPoule,
              loserDestNum,
              loserOccupant ? vacatedSpot : null,
              null,
              false,
              this.props.tournament,
              this.props.poulesByKey,
              this.props.bracketsByKey,
              this.props.resultSpotsAll,
              this.props.teams,
              poule.fase
            );
          }
        }
      }
    }

    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        onlyNextMatch: true,
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }

    batch.commit();
    if (!clear) {
      if (s1 === null && s2 === null) {
        this.submitPlayerStats();
      } else {
        // only playerPoints
        const db = window.firebase.firestore();

        const matchesRef = db
          .collection("tournaments")
          .doc(this.props.tournament[".key"])
          .collection("matches");
        matchesRef.doc(this.props.match.id).update({
          playerPoints: this.state.playerPoints,
        });
      }
    }
    if (window.firebase.analytics) {
      window.firebase.analytics().logEvent("match_result_submitted");
    }
    this.toggleDialog();
  };

  toggleDialog = () => {
    if ((this.props.tournamentStatus || {}).closed) {
      this.props.toggleFinishedDialog();
    } else {
      if (!this.state.open) {
        this.updateState();
      }
      this.setState({
        open: !this.state.open,
      });
    }
  };

  updateState = () => {
    this.setState({
      score1:
        this.props.match.score1 !== null
          ? this.props.match.score1.toString()
          : null,
      score2:
        this.props.match.score2 !== null
          ? this.props.match.score2.toString()
          : null,
      penalties1:
        this.props.match.penalties1 !== null &&
        this.props.match.penalties1 !== undefined
          ? this.props.match.penalties1.toString()
          : null,
      penalties2:
        this.props.match.penalties2 !== null &&
        this.props.match.penalties2 !== undefined
          ? this.props.match.penalties2.toString()
          : null,
      winner:
        this.props.match.winner !== undefined &&
        this.props.match.winner !== null
          ? this.props.match.winner.toString()
          : null,
      extra1: this.props.match.extra1 ? this.props.match.extra1 : {},
      extra2: this.props.match.extra2 ? this.props.match.extra2 : {},
      sets: this.props.match.sets ? { ...this.props.match.sets } : {},
      playerGoals: this.props.match.goals
        ? this.props.match.goals
            .filter(
              (pg) =>
                this.props.playersByKey[pg] !== undefined ||
                pg === "ownGoal1" ||
                pg === "ownGoal2"
            )
            .slice()
        : [],
      playerPoints: this.props.match.playerPoints
        ? this.props.match.playerPoints
        : {},
    });
  };

  UNSAFE_componentWillMount = () => {
    this.updateState();
    const poule = this.props.poulesByKey[this.props.match.poule] || {};
    let pouleKeyName = poule.fase;
    if (poule.bracket) {
      let bracket = this.props.bracketsByKey[poule.bracket] || {};
      pouleKeyName =
        poule.bracketRound === bracket.size && !bracket.subBracketTo
          ? poule.fase
          : poule.fase + "-" + poule.bracketRound + "-" + poule.bracket;
    }

    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    this.unsubscribeTeam1 = tournamentRef
      .collection("teams")
      .where("poule" + pouleKeyName, "==", this.props.match.poule)
      .where("numInPoule" + pouleKeyName, "==", this.props.match.team1)
      .limit(1)
      .onSnapshot((querySnapshot) => {
        if (querySnapshot.empty) {
          this.setState({ team1: "", team1Loaded: true });
        }
        querySnapshot.forEach((doc) => {
          this.setState({
            team1: doc.data().gamertag || doc.data().name,
            team1Loaded: true,
            team1Id: doc.id,
          });
        });
      });

    this.unsubscribeTeam2 = tournamentRef
      .collection("teams")
      .where("poule" + pouleKeyName, "==", this.props.match.poule)
      .where("numInPoule" + pouleKeyName, "==", this.props.match.team2)
      .limit(1)
      .onSnapshot((querySnapshot) => {
        if (querySnapshot.empty) {
          this.setState({ team2: "", team2Loaded: true });
        }
        querySnapshot.forEach((doc) => {
          this.setState({
            team2: doc.data().gamertag || doc.data().name,
            team2Loaded: true,
            team2Id: doc.id,
          });
        });
      });
  };

  componentWillUnmount = () => {
    this.unsubscribeTeam1();
    this.unsubscribeTeam2();
  };

  render() {
    let poule = this.props.poulesByKey[this.props.match.poule] || {};
    let scoreType =
      poule.scoreType ||
      (poule.bracket
        ? (this.props.bracketsByKey[poule.bracket] || {})["scoreType"]
        : false) ||
      ((this.props.tournament.scoringTypesPerDivisionPerPhase || {})[
        poule.division
      ] || {})[poule.fase] ||
      "default";
    let scoring =
      scoreType === "default"
        ? this.props.tournament
        : (this.props.tournament.scoringTypes || {})[scoreType] ||
          this.props.tournament;

    let playerGoals = this.state.playerGoals;
    let showPlayerStats = false;
    let ResultsDialog = SubmitResultDialog;
    let fullScreenMode = false;
    if (Object.keys(this.props.tournament.playerPoints || {}).length > 0) {
      showPlayerStats = true;
      if (
        (this.props.tournament.playerPoints || {})["0"] !== undefined &&
        (scoring.useSets || "0") === "0"
      ) {
        ResultsDialog = SubmitResultFullscreen;
        playerGoals = (this.props.match.goals || [])
          .filter(
            (pg) =>
              this.props.playersByKey[pg] !== undefined ||
              pg === "ownGoal1" ||
              pg === "ownGoal2"
          )
          .slice();
        fullScreenMode = true;
      }
    }
    let playerGoalsMatch = [];
    let goals1 = 0;
    let goals2 = 0;
    playerGoals.forEach((g) => {
      let player = this.props.playersByKey[g];
      if (player) {
        if (player.team === this.state.team1Id) {
          goals1++;
        } else if (player.team === this.state.team2Id) {
          goals2++;
        }
        playerGoalsMatch.push("(" + goals1 + " - " + goals2 + ")");
      } else if (g === "ownGoal1") {
        goals1++;
        playerGoalsMatch.push("(" + goals1 + " - " + goals2 + ")");
      } else if (g === "ownGoal2") {
        goals2++;
        playerGoalsMatch.push("(" + goals1 + " - " + goals2 + ")");
      }
    });

    let pouleMatches = this.props.matches.filter(
      (match) => match.poule === this.props.match.poule
    );
    if (!poule.bracket && !poule.singleMatch) {
      // let otherMatchInPoule = undefined;
      // if (poule.doubleMatches) {
      //   otherMatchInPoule = pouleMatches.find(
      //     (m) =>
      //       m.numInPoule ===
      //       (this.props.match.numInPoule >= pouleMatches.length / 2
      //         ? this.props.match.numInPoule - pouleMatches.length / 2
      //         : this.props.match.numInPoule + pouleMatches.length / 2)
      //   );
      // }
      pouleMatches = [this.props.match];
      // if (otherMatchInPoule) {
      //   pouleMatches.push(otherMatchInPoule);
      // }
    }
    let team1 = this.state.team1;
    let team2 = this.state.team2;

    if (team1 === "") {
      team1 =
        this.props.resultSpotsAll.filter(
          (resultSpot) =>
            resultSpot["poule" + poule.fase] === this.props.match.poule &&
            resultSpot["numInPoule" + poule.fase] === this.props.match.team1
        )[0] || "";
      if (team1 !== "") {
        team1 = getResultSpotName(
          team1,
          this.props.resultSpotsAll,
          this.props.poulesByKey,
          this.props.divisionsObject
        );
      }
    }

    if (team2 === "") {
      team2 =
        this.props.resultSpotsAll.filter(
          (resultSpot) =>
            resultSpot["poule" + poule.fase] === this.props.match.poule &&
            resultSpot["numInPoule" + poule.fase] === this.props.match.team2
        )[0] || "";
      if (team2 !== "") {
        team2 = getResultSpotName(
          team2,
          this.props.resultSpotsAll,
          this.props.poulesByKey,
          this.props.divisionsObject
        );
      }
    }
    if (team1 === "") {
      team1 =
        languages.structure.emptySpot +
        " " +
        (Number(this.props.match.team1) + 1).toString();
    }

    if (team2 === "") {
      team2 =
        languages.structure.emptySpot +
        " " +
        (Number(this.props.match.team2) + 1).toString();
    }

    let useSets = (scoring.useSets || "0") === "1";
    let filledIn = false;
    if (
      this.props.match.score1 !== null &&
      this.props.match.score2 !== null &&
      !useSets
    ) {
      filledIn = true;
    }

    let submitDisabled = true;
    if (
      (this.state.score1 === null && this.state.score2 === null) ||
      (this.state.score1 !== null && this.state.score2 !== null)
    ) {
      submitDisabled = false;
    }
    // if (
    //   isNormalInteger(this.state.score1) &&
    //   isNormalInteger(this.state.score2)
    // ) {
    //   submitDisabled = false;
    // }

    let gameResults = getGameResults(scoring, this.props.match.sets || {});
    let gameResultsState = getGameResults(
      // used for showing deciding set based on sets in state
      scoring,
      this.state.sets
    );
    let showCheckboxes = false;
    let showPenalties = false;
    let showPenaltiesInMatchButton = false;
    const invalidSetDraw = hasInvalidSetDrawForSetsType0(
      this.state.sets,
      scoring
    );
    if (
      poule.bracket ||
      poule.singleMatch ||
      (scoring.advancedGroupRanking && scoring.noDraw && !useSets)
    ) {
      if (pouleMatches.length === 1) {
        if (
          useSets
            ? !invalidSetDraw &&
              gameResultsState.finished &&
              gameResultsState.result1 === gameResultsState.result2
            : (fullScreenMode ? goals1 : this.state.score1) !== null &&
              (fullScreenMode ? goals2 : this.state.score2) !== null &&
              (fullScreenMode ? goals1 : this.state.score1) ===
                (fullScreenMode ? goals2 : this.state.score2)
        ) {
          showCheckboxes = true;
        }
      } else if (pouleMatches.length === 2) {
        let otherMatch = pouleMatches.filter(
          (match) => match.id !== this.props.match.id
        )[0];
        if (useSets) {
          const otherGameResults = getGameResults(
            scoring,
            otherMatch.sets || {}
          );
          const otherInvalidSetDraw = hasInvalidSetDrawForSetsType0(
            otherMatch.sets || {},
            scoring
          );
          if (
            !invalidSetDraw &&
            !otherInvalidSetDraw &&
            gameResultsState.finished &&
            otherGameResults.finished
          ) {
            const otherR1 =
              otherMatch.team1 === this.props.match.team1
                ? otherGameResults.result1
                : otherGameResults.result2;
            const otherR2 =
              otherMatch.team2 === this.props.match.team2
                ? otherGameResults.result2
                : otherGameResults.result1;
            if (
              gameResultsState.result1 + otherR1 ===
              gameResultsState.result2 + otherR2
            ) {
              showCheckboxes = true;
            }
          }
        } else if (otherMatch.score1 !== null && otherMatch.score2 !== null) {
          if (
            (fullScreenMode ? goals1 : this.state.score1) !== null &&
            (fullScreenMode ? goals2 : this.state.score2) !== null &&
            Number(fullScreenMode ? goals1 : this.state.score1) +
              (otherMatch.team1 === this.props.match.team1
                ? otherMatch.score1
                : otherMatch.score2) ===
              Number(fullScreenMode ? goals2 : this.state.score2) +
                (otherMatch.team2 === this.props.match.team2
                  ? otherMatch.score2
                  : otherMatch.score1)
          ) {
            showCheckboxes = true;
          }
        }
      }
    }
    if (scoring.enterPenaltyScores && showCheckboxes && !useSets) {
      showCheckboxes = false;
      showPenalties = true;
      if (
        this.state.penalties1 === null ||
        this.state.penalties2 === null ||
        this.state.penalties1 === this.state.penalties2
      ) {
        submitDisabled = true;
      }
    }
    if (showCheckboxes && this.state.winner === null) {
      submitDisabled = true;
    }

    let customPointsForMatch = [];
    Object.keys(this.props.tournament.customPoints || {}).forEach((key) => {
      let customPoints = this.props.tournament.customPoints[key];
      if (
        ((this.props.match.extra1 || {})[key] ||
          (this.props.match.extra2 || {})[key]) &&
        customPoints.showUnderResults
      ) {
        let string = `${customPoints.abbr}: ${
          (this.props.match.extra1 || {})[key] || 0
        } - ${(this.props.match.extra2 || {})[key] || 0}`;
        customPointsForMatch.push(string);
      }
    });

    let setsArray = [];
    for (let i = 0; i < Number(scoring.numSets || "2"); i++) {
      setsArray.push(i);
    }

    let score1 = this.props.match.score1;
    let score2 = this.props.match.score2;

    if (useSets) {
      if (gameResults.finished) {
        filledIn = true;
        if ((scoring.setsType || 0) === 0) {
          score1 = gameResults.result1;
          score2 = gameResults.result2;
        }
      }
    }

    let score1Style = { fontWeight: 400 };
    let score2Style = { fontWeight: 400 };

    if (
      score1 !== null &&
      score2 !== null &&
      (!useSets || ((scoring.setsType || 0) === 0 && gameResults.finished))
    ) {
      if (Number(score1) > Number(score2)) {
        score1Style = { fontWeight: 500 };
      } else if (Number(score1) < Number(score2)) {
        score2Style = { fontWeight: 500 };
      } else {
        if (this.props.match.winner === this.props.match.team1) {
          score1Style = { fontWeight: 500 };
        } else if (this.props.match.winner === this.props.match.team2) {
          score2Style = { fontWeight: 500 };
        }
        if (
          !useSets &&
          scoring.enterPenaltyScores &&
          this.props.match.penalties1 !== null &&
          this.props.match.penalties1 !== undefined &&
          this.props.match.penalties2 !== null &&
          this.props.match.penalties2 !== undefined
        ) {
          showPenaltiesInMatchButton = true;
        }
      }
    }

    let perSet =
      (scoring.useSets || "0") === "1" && (scoring.setsType || 0) === 1;

    let setResults = "";
    let numSetsFilledIn = 0;
    Object.keys(gameResults.sets).forEach((key, i) => {
      numSetsFilledIn++;
      let set = gameResults.sets[key];
      setResults += set.score1 + "-" + set.score2;
      if (i < Object.keys(gameResults.sets).length - 1) {
        setResults += ", ";
      }
    });

    if (useSets) {
      Object.keys(this.state.sets).forEach((key) => {
        let set = this.state.sets[key];
        if (hasSetScores(set.score1, set.score2)) {
          if (set.score1 === set.score2 && (scoring.setsType || 0) === 0) {
            submitDisabled = true;
          }
        }
      });
    }

    let markConflict = false;
    let lastId = "";
    let lastHistoryItem = null;
    Object.keys(this.props.match.history || {})
      .sort((a, b) => a - b)
      .forEach((h) => {
        let historyItem = this.props.match.history[h];
        if (
          historyItem.as === "team" &&
          historyItem.asId &&
          lastId !== historyItem.asId
        ) {
          if (lastId !== "" && lastId !== "admin") {
            markConflict = true;
          }

          if (
            markConflict &&
            lastHistoryItem &&
            compareHistoryItems(scoring, historyItem, lastHistoryItem)
          ) {
            if (poule.bracket) {
              if (historyItem.winner === lastHistoryItem.winner) {
                markConflict = false;
              }
            } else {
              markConflict = false;
            }
          }
          if (lastHistoryItem && lastId !== "" && lastId !== "admin") {
            Object.keys(historyItem.extra1 || {}).forEach((key) => {
              let extraValue = historyItem.extra1[key];
              let extraValueOpponent = (lastHistoryItem.extra1 || {})[key];
              if (extraValue !== extraValueOpponent) {
                markConflict = true;
              }
            });
            Object.keys(historyItem.extra2 || {}).forEach((key) => {
              let extraValue = historyItem.extra2[key];
              let extraValueOpponent = (lastHistoryItem.extra2 || {})[key];
              if (extraValue !== extraValueOpponent) {
                markConflict = true;
              }
            });
            Object.keys(lastHistoryItem.extra1 || {}).forEach((key) => {
              let extraValue = lastHistoryItem.extra1[key];
              let extraValueOpponent = (historyItem.extra1 || {})[key];
              if (extraValue !== extraValueOpponent) {
                markConflict = true;
              }
            });
            Object.keys(lastHistoryItem.extra2 || {}).forEach((key) => {
              let extraValue = lastHistoryItem.extra2[key];
              let extraValueOpponent = (historyItem.extra2 || {})[key];
              if (extraValue !== extraValueOpponent) {
                markConflict = true;
              }
            });
          }
          lastId = historyItem.asId;
          lastHistoryItem = historyItem;
        }
        if (historyItem.as === "admin") {
          markConflict = false;
          lastId = "admin";
        }
      });

    return this.state.team1Loaded && this.state.team2Loaded ? (
      <tr>
        {!this.state.isMobile && !this.props.online && (
          <td className="ResultsTableColumn">
            <Typography variant="body2">
              {this.props.tournament.fields[this.props.match.field].name}
            </Typography>
          </td>
        )}
        <td className="TeamName1">
          <Typography variant="body2">{team1}</Typography>
        </td>
        <td
          valign="middle"
          align="center"
          style={{
            width:
              110 +
              (numSetsFilledIn > 2 && perSet ? (numSetsFilledIn - 2) * 35 : 0),
          }}
        >
          <ResultsDialog
            tournament={this.props.tournament}
            scoring={scoring}
            open={this.state.open}
            toggleDialog={this.toggleDialog}
            handleSubmit={this.handleSubmit}
            handleScoreChange={this.handleScoreChange}
            handlePenaltiesChange={this.handlePenaltiesChange}
            team1={team1}
            team2={team2}
            team1Id={this.state.team1Id}
            team2Id={this.state.team2Id}
            score1={this.state.score1}
            score2={this.state.score2}
            penalties1={this.state.penalties1}
            penalties2={this.state.penalties2}
            match={this.props.match}
            submitDisabled={submitDisabled}
            showCheckboxes={showCheckboxes}
            showPenalties={showPenalties}
            winner={this.state.winner}
            handleCheck={this.handleCheck}
            missingTeams={this.state.team1 === "" || this.state.team2 === ""}
            fase={poule.fase}
            handleExtraChange={this.handleExtraChange}
            extra1={this.state.extra1}
            extra2={this.state.extra2}
            sets={this.state.sets}
            poule={this.props.poulesByKey[this.props.match.poule] || {}}
            setsArray={setsArray}
            handleSetsChange={this.handleSetsChange}
            gameResults={gameResults}
            gameResultsState={gameResultsState}
            showPlayerStats={showPlayerStats}
            players={this.props.players.filter(
              (p) =>
                p.team === this.state.team1Id || p.team === this.state.team2Id
            )}
            playersByKey={this.props.playersByKey}
            handleGoalChange={this.handleGoalChange}
            playerGoals={playerGoals}
            playerGoalsMatch={playerGoalsMatch}
            playerPoints={this.state.playerPoints}
            handlePlayerPointsChange={this.handlePlayerPointsChange}
            startTime={this.props.startTime}
            handlePlayerPresentCheck={this.handlePlayerPresentCheck}
            goals1={goals1}
            goals2={goals2}
            submitNewGoal={this.submitNewGoal}
            deleteGoal={this.deleteGoal}
            refereesByKey={this.props.refereesByKey}
            divisionsObject={this.props.divisionsObject}
          />
          <Button
            variant={markConflict ? "contained" : "outlined"}
            onClick={this.toggleDialog}
            size="small"
            color={
              filledIn ? (markConflict ? "secondary" : "primary") : "secondary"
            }
          >
            {!perSet &&
              (filledIn ? (
                <span>
                  <span style={score1Style}>{score1}</span> -{" "}
                  <span style={score2Style}>{score2}</span>
                  {showPenaltiesInMatchButton && (
                    <span>
                      {" (" +
                        this.props.match.penalties1.toString() +
                        " - " +
                        this.props.match.penalties2.toString() +
                        ")"}
                    </span>
                  )}
                </span>
              ) : (
                languages.results.fillIn
              ))}
            {perSet &&
              (setResults.length > 0 ? (
                <span style={{ whiteSpace: "nowrap" }}>{setResults}</span>
              ) : (
                languages.results.fillIn
              ))}
          </Button>
          <br />
          {customPointsForMatch.map((c, i) => {
            return (
              <div
                key={i}
                style={{
                  whiteSpace: "nowrap",
                  fontSize: 10,
                }}
              >
                {c}
              </div>
            );
          })}
        </td>
        <td className="TeamName2">
          <Typography variant="body2">{team2}</Typography>
        </td>
        {this.state.isMobile && !this.props.online && (
          <td className="ResultsTableColumn">
            <Typography variant="body2">
              {this.props.tournament.fields[this.props.match.field].name}
            </Typography>
          </td>
        )}
        <td className="ResultsTableColumn">
          <Typography
            variant="body2"
            style={{
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={() => {
              this.props.selectPoule(poule.id);
            }}
          >
            {poule.name}
            {this.props.divisions.length > 1 &&
              " - " + (this.props.divisionsObject[poule.division] || {}).name}
          </Typography>
        </td>
        {this.props.showReferees && (
          <td className="ResultsTableColumn">
            {this.props.match.referee && (
              <Typography variant="body2">
                <Icon
                  path={mdiWhistle}
                  size={0.6}
                  color={"rgba(0, 0, 0, 0.54)"}
                  style={{ marginRight: 2 }}
                />
                {(this.props.refereesByKey[this.props.match.referee] || {})
                  .name || ""}
              </Typography>
            )}
          </td>
        )}
        {this.props.showReferees2 && (
          <td className="ResultsTableColumn">
            {this.props.match.referee2 && (
              <Typography variant="body2">
                <Icon
                  path={mdiWhistle}
                  size={0.6}
                  color={"rgba(0, 0, 0, 0.54)"}
                  style={{ marginRight: 2 }}
                />
                {(this.props.refereesByKey[this.props.match.referee2] || {})
                  .name || ""}
              </Typography>
            )}
          </td>
        )}
        {this.props.showReferees3 && (
          <td className="ResultsTableColumn">
            {this.props.match.referee3 && (
              <Typography variant="body2">
                <Icon
                  path={mdiWhistle}
                  size={0.6}
                  color={"rgba(0, 0, 0, 0.54)"}
                  style={{ marginRight: 2 }}
                />
                {(this.props.refereesByKey[this.props.match.referee3] || {})
                  .name || ""}
              </Typography>
            )}
          </td>
        )}
        {this.props.showReferees4 && (
          <td className="ResultsTableColumn">
            {this.props.match.referee4 && (
              <Typography variant="body2">
                <Icon
                  path={mdiWhistle}
                  size={0.6}
                  color={"rgba(0, 0, 0, 0.54)"}
                  style={{ marginRight: 2 }}
                />
                {(this.props.refereesByKey[this.props.match.referee4] || {})
                  .name || ""}
              </Typography>
            )}
          </td>
        )}
        {this.props.showReferees5 && (
          <td className="ResultsTableColumn">
            {this.props.match.referee5 && (
              <Typography variant="body2">
                <Icon
                  path={mdiWhistle}
                  size={0.6}
                  color={"rgba(0, 0, 0, 0.54)"}
                  style={{ marginRight: 2 }}
                />
                {(this.props.refereesByKey[this.props.match.referee5] || {})
                  .name || ""}
              </Typography>
            )}
          </td>
        )}
      </tr>
    ) : (
      <tr style={{ height: 34 }} />
    );
  }
}

export default MatchContainer;
